import { createContext, useContext } from 'react';

export type CollectionContextValue = {
  isSelecting: boolean;
  selectedIds: Set<string>;
  toggleListing: (id: string) => void;
  // Set while a shared collection is open; restricts map popups to it.
  viewingCode: string | null;
  viewingListingIds: string[] | null;
};

const noop = () => undefined;

// Default keeps cards and map popups outside /search unaffected.
export const CollectionContext = createContext<CollectionContextValue>({
  isSelecting: false,
  selectedIds: new Set(),
  toggleListing: noop,
  viewingCode: null,
  viewingListingIds: null,
});

export const useCollectionContext = () => useContext(CollectionContext);
